/**
 * Helper estandar para formatear estados en ventanas de navegabilidad.
 * Convierte IdEstado (2: A, 3: I, 4: N) o descripciones ('Activo', 'Inactivo', 'Anulado')
 * en su codigo abreviado centrado ('A', 'I', 'N').
 */
export const formatearCodigoEstado = (valor, row) => {
    const id = row?.idEstado != null ? row.idEstado : (typeof valor === 'number' ? valor : null);
    if (id === 2) return 'A';
    if (id === 3) return 'I';
    if (id === 4) return 'N';

    const texto = String(valor ?? row?.estado ?? '').trim();
    if (!texto) return '';
    if (/^activo$/i.test(texto) || texto === 'A') return 'A';
    if (/^inactivo$/i.test(texto) || texto === 'I') return 'I';
    if (/^anulado$/i.test(texto) || texto === 'N') return 'N';
    if (texto.length === 1) return texto.toUpperCase();
    return texto.charAt(0).toUpperCase();
};

export const columnaEstadoEstandar = (props = {}) => ({
    field: 'estado',
    headerName: 'Estado',
    width: 75,
    minWidth: 65,
    sortable: true,
    headerAlign: 'center',
    align: 'center',
    renderCell: (p) => formatearCodigoEstado(p.value, p.row),
    ...props,
});

